'use strict';

var style = require('./style');

module.exports = style({
  prop: 'letterSpacing',
  key: 'letterSpacings',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/letter-spacing.js
// module id = 94
// module chunks = 35783957827783 95816961762493 114276838955818 231178572073751